import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { usableIcons } from '../icon/icon.component';

@Component({
  selector: 'vee-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  standalone: false,
})
export class EmptyStateComponent {
  @Input() message!: string;
  @Input() ctaLabel?: string;
  @Input() ctaIcon?: usableIcons;
  @Output() cta = new EventEmitter<void>();

  // Standalone usage (e.g. an empty list) wants its own card border; nested
  // usage (e.g. inside a row that already has one) doesn't, or it doubles up.
  @Input() bordered = true;

  @HostBinding('class.bordered')
  get isBordered(): boolean {
    return this.bordered;
  }
}
